import { Switch } from "react-native-switch";

const CustomSwitch = ({value, onValueChange, disabled, onColor="#4785b8", offColor="gray", disabledColor = "lightgray", circleActiveColor = "#eee", circleInActiveColor="#eee"}) => {
    return (
        <Switch
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        activeText={"On"}
        inActiveText={"Off"}
        circleSize={25}
        barHeight={20}
        circleBorderWidth={1.5}
        circleBorderInactiveColor={disabled?disabledColor:offColor}
        circleBorderActiveColor={disabled?disabledColor:onColor}
        backgroundActive={disabled?disabledColor:onColor}
        backgroundInactive={disabled?disabledColor:offColor}
        circleActiveColor={circleActiveColor}
        circleInActiveColor={circleInActiveColor}
        changeValueImmediately={true}
        innerCircleStyle={{
          alignItems: "center",
          justifyContent: "center",
        }}
        outerCircleStyle={{}}
        renderActiveText={false}
        renderInActiveText={false}
        switchLeftPx={2}
        switchRightPx={2}
        switchWidthMultiplier={1.5}
        switchBorderRadius={30}
      />

    );
}
export default CustomSwitch;
